<div id="outer-box" *ngIf="loading" [style.min-height]="height" [style.width]="width">
  <img [src]="src" [style.height]="imageHeight" [style.width]="imageWidth" />
  <div id="inner-box" [style.background-color]="bgColor"></div>
</div>
<div *ngIf="!loading"><ng-content></ng-content></div>

<!--
  <div [id]="loading ? 'outer-box' : ''">
      <img *ngIf="loading" [src]="src" [style.height]="height" [style.width]="width" />
      <div [id]="loading ? 'inner-box' : ''">
          <div [id]="loading ? 'content' : ''">
              <ng-content></ng-content>
          </div>
      </div>
  </div>
-->
